import { Reward, StampCard, Voucher } from './index';

export type AutomationTriggerType =
  | 'customer_takes_loyalty_card'
  | 'schedule';

export interface AutomationTrigger {
  type: AutomationTriggerType;
}

export interface AutomationAction {
  type: 'push_notification' | 'give_rewards';
  message?: string;
  reward?: string | Reward; // Legacy single reward support
  rewards?: (string | Reward)[]; // New multiple rewards support
}

export interface AutomationConditions {
  cards?: (string | StampCard)[];
}

export interface AutomationTarget {
  type: 'all_customers' | 'filtered_customers';
  filters?: {
    birthdayThisMonth?: boolean;
    receivedReward?: boolean;
    specificRewardNotReceived?: boolean;
    specificRewardNotReceivedMonths?: number;
    specificRewardNotReceivedReward?: string;
    redeemedReward?: boolean;
    receivedStamp?: boolean;
    receivedNotification?: boolean;
    hasVoucher?: boolean;
    unredeemedRewards?: boolean;
    lapsedStamps?: boolean;
    lapsedStampsDays?: number;
  };
  cards?: (string | StampCard)[];
  vouchers?: (string | Voucher)[];
  voucherStatus?: string[];
}

export interface AutomationFrequency {
  type: 'once' | 'daily' | 'weekly' | 'monthly' | 'specific_date' | 'milestone';
  date?: Date | string;
  time?: string;
  dayOfWeek?: number;
  dayOfMonth?: number;
  milestoneType?: 'stamp_count';
  milestoneCard?: string | StampCard;
  milestoneThreshold?: number;
  lastExecuted?: Date | string;
  nextExecution?: Date | string;
}

export interface AutomationExecutionResult {
  success?: boolean;
  recipientCount?: number;
  executedAt?: Date | string;
  error?: string;
}

export interface Automation {
  _id?: string;
  nanoid?: string;
  merchant?: string;
  name: string;
  enabled?: boolean;
  trigger?: AutomationTrigger;
  conditions?: AutomationConditions;
  action: AutomationAction;
  target?: AutomationTarget;
  frequency?: AutomationFrequency;
  executionCount?: number;
  lastExecutionResult?: AutomationExecutionResult;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}
